import { GameConfigDTO } from '@envclient/envcore/src/types/core';

const isSupported = (gameConfig: GameConfigDTO, appVersion: number) => {
  if (!gameConfig) return false;
  return gameConfig.minVersion <= appVersion;
};

export { isSupported };
